import { Injectable } from '@angular/core';

/**
 * Class of app messages
 */
@Injectable()
export class Messages {
    private resource: any = {
        "LOGIN_SUCCESS" : "Seja bem vindo",
        "LOGIN_FAIL" : "Usuário ou senha inválidos",
        "ATTENTION": "Atenção",
        "HELLO": "Olá" 
    }

    /**
     * 
     * @param key 
     */
    getMessage(key: string): string{
        return this.resource[key];
    }
}